export default __webpack_public_path__ + "static/media/helpline.7da004d5.svg";